<div class="app-button-container app-flex app-flex-middle">
  <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
    <span class="app-key app-key-unimportant">{{ decisionKeys[0] | titlecase }}</span>
    @if (type !== 'priming') {
      <button
        value="unimportant"
        class="app-btn app-btn-hov-green"
        (click)="triggerDecision(0)"
        >
        {{ keyLabels[0] | titlecase }}
      </button>
    }
    @if (type === 'priming') {
      <button value="unimportant" class="app-btn-primer" [disabled]="true">
        {{ keyLabels[0] | titlecase }}
      </button>
    }
  </div>
  <div class="app-button-input-container app-flex app-flex-column app-flex-middle">
    <span class="app-key app-key-important">{{ decisionKeys[1] | titlecase }}</span>
    @if (type !== 'priming') {
      <button value="important" class="app-btn app-btn-hov-green" (click)="triggerDecision(1)">
        {{ keyLabels[1] | titlecase }}
      </button>
    }
    @if (type === 'priming') {
      <button value="important" class="app-btn-primer" [disabled]="true">
        {{ keyLabels[1] | titlecase }}
      </button>
    }
  </div>
</div>
